module.exports = __webpack_public_path__ + "media/images/icon-svg/calendar-7137576c83d06fd4e50243fa6e3ddb86.svg";